import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestData } from 'src/app/common/models/request-data.model';
import { EmployeeJobTitleModel } from './model/employee-job-title.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeeJobTitleService {

  private baseUrl = environment.baseUrl + '/' + environment.app + '/employee-job-title/';

  constructor(private http: HttpClient) { }

  getList(requestData: RequestData): Observable<any> {
    return this.http.post(this.baseUrl + 'get', requestData);
  }

  getById(id: number): Observable<any> {
    return this.http.post(this.baseUrl + 'get/' + id, '');
  }

  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.baseUrl + 'export-job-title-list', requestData, { headers, responseType: 'blob' });
  }

  update(info: EmployeeJobTitleModel): Observable<any> {
    if (info.hasOwnProperty("id") && info.id !== 0) {
      return this.http.post(this.baseUrl + 'update', info);
    } else {
      return this.http.post(this.baseUrl + 'add', info);
    }
  }

  delete(info: EmployeeJobTitleModel): Observable<any> {
    return this.http.post(this.baseUrl + 'delete/' + info.id, info);
  }
}
